// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__8IjJp","preFooter":"Footer_preFooter__uenO1","middleFooter":"Footer_middleFooter__vIVg9"};